import React from 'react';
import { Wifi, WifiOff, Menu, X } from 'lucide-react';
import { useGateway } from '@/hooks/useGateway';
import { cn } from '@/lib/utils';

export const TopBar = ({ toggleSidebar, sidebarOpen, onLogout }) => {
  const { isConnected, loading, reconnect } = useGateway();

  return (
    <div className="bg-gray-900 border-b border-gray-800 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleSidebar}
            className="md:hidden p-2 hover:bg-gray-800 rounded-lg transition-colors"
            aria-label="Toggle sidebar"
          >
            {sidebarOpen ? (
              <X className="w-6 h-6 text-cyan-400" />
            ) : (
              <Menu className="w-6 h-6 text-cyan-400" />
            )}
          </button>
          <h2 className="text-xl font-semibold text-white">OpenClaw Control Center</h2>
        </div>

        <div className="flex items-center space-x-4">
          {/* Gateway Status */}
          <div 
            className={cn(
              'flex items-center px-4 py-2 rounded-lg border transition-all',
              isConnected
                ? 'bg-green-500/10 border-green-500/30 text-green-400'
                : 'bg-red-500/10 border-red-500/30 text-red-400'
            )}
            data-testid="gateway-status"
          >
            {isConnected ? (
              <>
                <Wifi className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">Gateway Connected</span>
                <div className="ml-2 w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              </>
            ) : (
              <>
                <WifiOff className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">Gateway Disconnected</span>
                {!loading && (
                  <button
                    onClick={reconnect}
                    className="ml-3 text-xs px-2 py-1 bg-red-500/20 hover:bg-red-500/30 rounded transition-colors"
                    data-testid="reconnect-button"
                  >
                    Reconnect
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
